export default "__VITE_ASSET__DBLt3qTg__"